
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":"2","y":"2","width":"20","height":"20","rx":"4","fill":"#63A2E4"}}),_c('path',{attrs:{"d":"M5.83 10.382a.359.359 0 01-.078-.261.374.374 0 01.143-.235l2.832-2.232c.07-.052.14-.1.209-.143a.44.44 0 01.248-.078h1.018c.095 0 .178.034.248.104.07.07.104.152.104.248v8.43a.339.339 0 01-.104.248.339.339 0 01-.248.104H9.145a.339.339 0 01-.248-.104.339.339 0 01-.105-.248V9.77L6.94 11.217a.359.359 0 01-.26.078.424.424 0 01-.236-.143l-.613-.77zM15.568 12.475c.21-.167.341-.338.397-.511.063-.175.094-.335.094-.48 0-.286-.087-.526-.261-.721-.174-.202-.463-.303-.867-.303-.382 0-.664.094-.845.282-.174.188-.3.428-.376.72a.355.355 0 01-.125.21.337.337 0 01-.188.062h-.825a.332.332 0 01-.209-.073.251.251 0 01-.073-.21c.021-.312.101-.608.24-.886.14-.279.324-.522.554-.731.236-.209.511-.373.824-.49.314-.126.651-.189 1.013-.189.439 0 .818.073 1.138.22.32.139.585.323.793.553.21.222.362.473.46.751.104.272.156.543.156.815 0 .174-.01.34-.03.5-.022.154-.07.31-.147.47a2.561 2.561 0 01-.334.491 4.599 4.599 0 01-.585.543l-1.931 1.764h2.902a.27.27 0 01.198.084.27.27 0 01.084.198v.742a.27.27 0 01-.084.198.27.27 0 01-.198.083h-4.875a.27.27 0 01-.199-.083.27.27 0 01-.083-.198v-.637c0-.119.035-.22.104-.303a.946.946 0 01.178-.188l3.1-2.683z","fill":"#fff"}})])
          )
        }
      }
    